import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const getAllUsersByCharger: UseCase<UserRepository, 'getAllByCharger'> = repository => {
  return async (chargerUid) => {
    return await repository.getAllByCharger(chargerUid)
  }
}
